import './styles.css';
import { render } from 'preact';
import { registerSW } from 'virtual:pwa-register';
import { makeT } from './i18n';
import { resyncPush } from './push';
import { bootstrap, errorText, getState, refreshAll, set, toast } from './state';
import { App } from './views/App';
import { openCard } from './views/Mailbox';

const root = document.getElementById('app');
if (!root) throw new Error('#app is missing from index.html');
render(<App />, root);

// Refresh when the app comes back to the foreground: a card may have landed.
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible' && getState().user) void refreshAll();
});
window.addEventListener('online', () => {
  if (getState().user) void refreshAll();
});

/**
 * A notification links to /?card=<id>. Open that card once the mailbox has it,
 * then tidy the address so a reload doesn't open it again.
 */
async function openLinkedCard(href: string): Promise<void> {
  const url = new URL(href, window.location.origin);
  const id = url.searchParams.get('card');
  if (!id) return;
  url.searchParams.delete('card');
  window.history.replaceState({}, '', url.pathname + url.search + url.hash);
  if (!getState().user) return;

  let card = getState().mailbox.find((c) => c.id === id);
  if (!card) {
    await refreshAll();
    card = getState().mailbox.find((c) => c.id === id);
  }
  if (!card) return;
  set({ tab: 'mailbox', sentCard: null, zoomIndex: null, pickerOpen: false, addressOpen: false, confirmCancelId: null, editOpen: false });
  openCard(card);
}

// Tapping a notification while the app is already open arrives as a message.
navigator.serviceWorker?.addEventListener('message', (e: MessageEvent) => {
  const data = e.data as { type?: string; url?: string } | null;
  if (data?.type === 'open-url' && data.url) void openLinkedCard(data.url);
});

bootstrap()
  .then(() => {
    if (!getState().user) return;
    void openLinkedCard(window.location.href);
    void resyncPush();
  })
  .catch((err) => {
    set({ ready: true });
    toast(errorText(err, makeT(getState().lang)('genericError')), 'error');
  });

// Keep an installed copy current without nagging.
registerSW({ immediate: true });
